(function() {
  if (!window.location.href.includes("collections")) return;

  // Function to hide the badges
  function hideBadges() {
    const badges = document.querySelectorAll(".trust-badges-header-center .trust-badges-center");
    badges.forEach(el => {
      el.style.setProperty("display", "none", "important");
    });
  }

  // Initial attempt
  hideBadges();

  // Watch for dynamically added elements
  const observer = new MutationObserver(hideBadges);
  observer.observe(document.body, { childList: true, subtree: true });
})();
